import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Qbits9Main from './pages/QbitsMain';
import Contact from './pages/Contact';
import AIAutomation from './pages/services/AIAutomation';
import WebMobileDevelopment from './pages/services/WebMobileDevelopment';
import SaasErpDevelopment from './pages/services/SaasErpDevelopment';
import DesktopSoftware from './pages/services/DesktopSoftware';
import QbitsBlog from './pages/QbitsBlog';
import BlogPost from './pages/BlogPost';
import NotFound from './pages/NotFound';
import Lumina from './pages/Lumina';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ScrollToTop from './components/ScrollToTop';
import PageTransition from './components/PageTransition';
import CareIPD from './pages/CareIPD';

function App() {
    return (
        <Router>
            <ScrollToTop />
            <PageTransition />
            <Routes>
                <Route path="/" element={<Qbits9Main />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/services/ai-automation" element={<AIAutomation />} />
                <Route path="/services/web-mobile-development" element={<WebMobileDevelopment />} />
                <Route path="/services/saas-erp-development" element={<SaasErpDevelopment />} />
                <Route path="/services/desktop-software" element={<DesktopSoftware />} />
                <Route path="/lumina" element={<Lumina />} />
                <Route path="/hospital-management-software" element={<CareIPD />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/blog" element={<QbitsBlog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default App;
